import { Component, OnInit, Output, EventEmitter, ViewChild, Input, SimpleChanges, OnChanges } from '@angular/core';

import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { GeneralService } from 'src/app/services/general.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { NewCustomerComponent } from '../new-customer/new-customer.component';
import { NewServiceSiteComponent } from '../new-service-site/new-service-site.component';
import { Router } from '@angular/router';
import { MapInformationService } from 'src/app/services/map-information.service';

@Component({
  selector: 'app-new-empleoye-activities',
  templateUrl: './new-empleoye-activities.component.html',
  styleUrls: ['./new-empleoye-activities.component.scss']
})
export class NewEmpleoyeActivitiesComponent implements OnInit, OnChanges {
  @ViewChild(NewCustomerComponent, null) NewCustomer: NewCustomerComponent;
  @ViewChild(NewServiceSiteComponent, null) NewSite: NewServiceSiteComponent;

  @Input() viewedit = false;
  @Input() ActivityEmpl:any;
  @Input() popupEmployeeActivity = false;
  @Output() result = new EventEmitter();
  @Output() closeModal = new EventEmitter();
  @Output() formvalid = new EventEmitter();

  popupServiceSite = false;
  popupCustomer = false;

  public _formEntity: FormGroup;

  optionsCustomer: any;
  optionsempleoyees: any;
  optionsactivityType: any;
  optionsSite: any;
  optionsProject: any;

  varActType: number;

  now: Date = new Date();
  nowHour: Date = new Date();
  firstName: any;
  rules: any;

  titleModalActivity: string;
  // ActivityEmpl: any;

  IdAutocomplete: number;

  CustomerName: string;
  SiteNameVar: string;
  Projetcname: string;

  cancelButton: any;
  saveButton: any;
  saveNewButton: any;
  saveEditButton: any;


  cancelButtonNewCustomer: any;
  saveButtonNewCustomer: any;
  saveNewButtonNewCustomer: any;
  saveEditButtonNewCustomer: any;

  CustomerButton:any;
  ServiceSiteButton:any;

  @ViewChild('newcustomer', { static: false }) newcustomer: NewCustomerComponent;

  constructor(
    private customerService: CustomerService,
    private generalService: GeneralService,
    private toast: ToastService,
    private router: Router,
    public fb: FormBuilder,
    public MapInformationService: MapInformationService,
  ) {

    this.rules = { "X": /[02-9]/ };

    this.CustomerButton = {
      icon: "plus",
      type: "button",
      onClick:( ) => {
        this.showInfo2()
      }
    };

    this.ServiceSiteButton = {
      icon: "plus",
      type: "button",
      onClick:( ) => {
        this.showInfo3()
      }
    };


  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.ActivityEmpl != undefined){
      console.log("aqui")
      console.log(this.ActivityEmpl)
      this.ngOnInit()
    }
  }

  ngOnInit() {
    this.getCustomer();
    this.getDataToSelects();
    this.titleModalActivity = ""
    console.log(this.ActivityEmpl)
    this.initForm(this.ActivityEmpl);
    // this.Reload()


    this.cancelButton = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEmployeeActivity = false;
      },
    };

    this.saveButton = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.submitForm(true, false);
      },
    };

    this.saveNewButton = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.submitForm(false, false);
      },

    };

    this.saveEditButton = {
      text: 'Save & Edit',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.submitForm(true, true);
      },
    };


    this.cancelButtonNewCustomer = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupCustomer = false;
      },
    };

    this.saveButtonNewCustomer = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newcustomer.submitForm(true, false);
      },
    };

    this.saveNewButtonNewCustomer = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(false, false);
      },

    };

    this.saveEditButtonNewCustomer = {
      text: 'Save & Edit',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(true, true);
      },
    };

    // if (sessionStorage.getItem('ActivityEmpl')) {
    //   this.ActivityEmpl = JSON.parse(sessionStorage.getItem('ActivityEmpl'));
    //   // sessionStorage.removeItem('ActivityEmpl');
    //   this.titleModalActivity = ""
    //   this.initForm(this.ActivityEmpl);
    // } else {
    //   this.titleModalActivity = ""
    //   this.initForm();

    // }
  }

  Reload(){
    this._formEntity = new FormGroup({
      id: new FormControl({ value: "", disabled: false }, []),
      OptCustomer: new FormControl({ value: 0, disabled: false }, [Validators.required, Validators.maxLength(45)]),
      OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
      OptProject: new FormControl({ value: 0, disabled: false }, []),
      Hour: new FormControl({ value: "", disabled: false }, []),
      Minute: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Customer: new FormControl({ value: "", disabled: false }, []),
      ServiceSite: new FormControl({ value: "", disabled: false }, []),
      Project: new FormControl({ value: "", disabled: false }, []),
      // CusomerActivityId: new FormControl({ value: '', disabled: false }, []),
      Employee: new FormControl({ value: "", disabled: false }, [Validators.required]),
      siteaddress: new FormControl({ value: '', disabled: false }, []),
      ActivityType: new FormControl({ value: "", disabled: false }, []),
      Description: new FormControl({ value: "", disabled: false }, []),
      StartTime: new FormControl({ value: "", disabled: false }, []),
      EndTime: new FormControl({ value: '', disabled: false }, []),
      FollowUp: new FormControl({ value: "", disabled: false }, []),
      Name: new FormControl({ value: "", disabled: false }, []),
      Closed: new FormControl({ value: "", disabled: false }, []),
      FollowUpComments: new FormControl({ value: "", disabled: false }, []),
    });
  }

  initForm(data?: any) {
    if (data) {
      // console.clear()
      console.log('initForm sessionStorage', data);
      let mydate = new Date(data.DATE);
      this.now = mydate;
      this.nowHour = new Date(data.STARTTIME);
      let close;
      if (data.CLOSED === "No") {
        close = false;
      } else {
        close = true;
      }
      if (data.FOLLOWUP === 'No') {
        data.FOLLOWUP = false;
      } else { data.FOLLOWUP = true; }
      let duration;
      let dutationSub1 = data.DURATION + '';
      if (data.DURATION % 1 == 0) {
        //alert ("Es un numero entero");
        duration = data.DURATION + ':00'
        if (duration.length < 5) {
          duration = '0' + duration;
        }
      } else {
        //alert ("Es un numero decimal");
        if (dutationSub1.length < 5) {
          if (data.DURATION < 10) {
            if (data.DURATION < 1) {
              if (dutationSub1.length > 3) {
                duration = 0 + dutationSub1.replace('.', ":");
              } else {
                duration = 0 + dutationSub1.replace('.', ":") + 0;
              }
            } else {
              duration = 0 + dutationSub1.replace('.', ":");
              if (duration.length < 5) {
                duration = duration + '0';
              }
            }
          } else {
            duration = dutationSub1.replace('.', ":");
            duration = duration + '0';
          }
        } else {
          duration = dutationSub1.replace('.', ":");
        }
      }
      let idCustuimer;
      this.CustomerName = '';
      this.SiteNameVar = '';
      this.Projetcname = '';
      if (data.CUSTOMER !== "") {
        this.CustomerName = data.CUSTOMER;
        // this.IdAutocomplete = data.CUSTOMERID;
      }
      if (data.SiteName) {
        this.SiteNameVar = data.SiteName;
        // this.IdAutocomplete = data.ServiceSite;
      }
      if (data.ProjectName) {
        this.Projetcname = data.ProjectName;
        // this.IdAutocomplete = data.Project;
      }
      console.log(data)

      console.log('init edit');

      this._formEntity = new FormGroup({
        id: new FormControl({ value: data.ID, disabled: false }, []),
        OptCustomer: new FormControl({ value: 0, disabled: false }, [Validators.required, Validators.maxLength(45)]),
        OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
        OptProject: new FormControl({ value: 0, disabled: false }, []),
        Hour: new FormControl({ value: data.STARTTIME, disabled: false }, []),
        Minute: new FormControl({ value: duration, disabled: false }, [Validators.required]),
        Customer: new FormControl({ value: data.CUSTOMERID, disabled: false }, []),
        ServiceSite: new FormControl({ value: data.SERVICESITEID, disabled: false }, []),
        Project: new FormControl({ value: data.PROJECTID, disabled: false }, []),
        // CusomerActivityId: new FormControl({ value: '', disabled: false }, []),
        Employee: new FormControl({ value: data.EMPLOYEEID, disabled: false }, [Validators.required]),
        siteaddress: new FormControl({ value: '', disabled: false }, []),
        ActivityType: new FormControl({ value: data.TYPEID, disabled: false }, []),
        Description: new FormControl({ value: data.NOTES, disabled: false }, []),
        StartTime: new FormControl({ value: mydate, disabled: false }, []),
        EndTime: new FormControl({ value: '', disabled: false }, []),
        FollowUp: new FormControl({ value: data.FOLLOWUP, disabled: false }, []),
        Name: new FormControl({ value: data.NAME, disabled: false }, []),
        Closed: new FormControl({ value: close, disabled: false }, []),
        FollowUpComments: new FormControl({ value: data.FOLLOWUPCOMMENTS, disabled: false }, []),
      });

      if (data.CUSTOMER !== "") {
        this.optionsSelect('OptCustomer');
      }
      if (data.ServiceSite !== -1) {
        this.optionsSelect('serviceSite');
      }
      if (data.Project !== -1) {
        this.optionsSelect('project');
      }

      if (data.CUSTOMERID == -1) {
        this.CustomerName = "";
      }
      if (data.SERVICESITEID == -1) {
        this.SiteNameVar = ""
      }
      if (data.PROJECTID == -1) {
        this.Projetcname = ""
      }

      this.fomrvalid();

    } else {
      console.log('init dorm');

      this._formEntity = new FormGroup({
        OptCustomer: new FormControl({ value: 0, disabled: false }, [Validators.maxLength(45)]),
        OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
        OptProject: new FormControl({ value: 0, disabled: false }, []),
        Hour: new FormControl({ value: this.nowHour, disabled: false }, []),
        Minute: new FormControl({ value: '00:01', disabled: false }, [Validators.required]),
        Customer: new FormControl({ value: '', disabled: false }, []),
        ServiceSite: new FormControl({ value: '', disabled: false }, []),
        Project: new FormControl({ value: '', disabled: false }, []),
        // CusomerActivityId: new FormControl({ value: '', disabled: false }, []),
        Employee: new FormControl({ value: '', disabled: false }, [Validators.required]),
        siteaddress: new FormControl({ value: '', disabled: false }, []),
        ActivityType: new FormControl({ value: null, disabled: false }, []),
        Description: new FormControl({ value: '', disabled: false }, []),
        StartTime: new FormControl({ value: this.now, disabled: false }, []),
        EndTime: new FormControl({ value: '', disabled: false }, []),
        FollowUp: new FormControl({ value: false, disabled: false }, []),
        Name: new FormControl({ value: '', disabled: false }, []),
        Closed: new FormControl({ value: '', disabled: false }, []),
        FollowUpComments: new FormControl({ value: '', disabled: false }, []),
      });
    }


  }
  fomrvalid() {
    console.log('fomrvalid');

    if (this._formEntity.valid) {
      this.formvalid.emit({dara: 'as'});
    } else {
      this.formvalid.emit(false);
    }
  }
  optionType(e) {
    console.log('eve', e);
    if (e.selectedItem) {
      this.varActType = e.selectedItem.key;
      console.log('optionType', this.varActType);
    }
  }


  submitForm(closemodal, goedit) {
    let formValue;
    let hour, minute;
    minute = 0;
    formValue = this._formEntity.value;
    formValue.StartTime = this.convertADate(formValue.StartTime);
    formValue.StartTime = formValue.StartTime + ' ' + this.getHour(formValue.Hour);
    //Change Duration
    formValue.Minute = formValue.Minute.replace(':', "");
    hour = parseInt(formValue.Minute.substr(0, 2));
    minute = parseInt(formValue.Minute.substr(2, 2));
    formValue.Minute = minute;
    formValue.Hour = hour;
    //
    if (formValue.ActivityType === null) {
      formValue.ActivityType = this.varActType;
    }

    // Change boolean ton strin 0 and 1
    if (formValue.FollowUp === true) {
      formValue.FollowUp = parseInt('1');
    } else { formValue.FollowUp = parseInt('0'); }
    // Close
    if (formValue.Closed === true) {
      formValue.Closed = parseInt('1');
    } else { formValue.Closed = parseInt('0'); }
    // END hange boolean ton strin 0 and 1
    if (formValue.Name === "") {
      formValue.Name = "New Activity";
    }



    // if (formValue.OptCustomer === 1) {
    //   if (this.ActivityEmpl && this.IdAutocomplete < 1) {
    //     this.IdAutocomplete = this.ActivityEmpl.CUSTOMERID;
    //     // formValue.Customer = this.ActivityEmpl.CUSTOMERID;
    //   } else {
    //     formValue.Customer = this.IdAutocomplete;
    //   }
    //   formValue.Customer = this.IdAutocomplete;
    //   // formValue.Project = 0;
    //   // formValue.ServiceSite = 0;
    // }

    // if (formValue.OptServiceSite === 1) {
    //   if (this.ActivityEmpl && this.IdAutocomplete < 1) {

    //     // formValue.ServiceSite = this.ActivityEmpl.CUSTOMERID;
    //   } else {
    //     formValue.ServiceSite = this.IdAutocomplete;
    //   }
    //   // formValue.Project = 0;
    //   // formValue.Customer = 0;
    // }

    // if (formValue.OptProject === 1) {
    //   if (this.ActivityEmpl && this.IdAutocomplete < 1) {
    //     // formValue.Project = this.ActivityEmpl.CUSTOMERID;
    //   } else {
    //     formValue.Project = this.IdAutocomplete;
    //   }
    //   formValue.Project = this.IdAutocomplete;
    //   // formValue.ServiceSite = 0;
    //   // formValue.Customer = 0;
    // }

    if (formValue.Project === "") {
      formValue.Project = 0;
    }
    if (formValue.Customer === "") {
      formValue.Customer = 0;
    }

    if (formValue.ServiceSite === "") {
      formValue.ServiceSite = 0;
    }



    if (formValue.Project === 0 || formValue.Project === undefined || formValue.Project === "" || formValue.Project === -1) {
      formValue.OptProject = 0;
    } else {
      formValue.OptProject = 1;
    }
    if (formValue.Customer === "" || formValue.Customer === undefined || formValue.Customer === 0 || formValue.Customer === -1) {
      formValue.OptCustomer = 0;
    } else {
      formValue.OptCustomer = 1;
    }

    if (formValue.ServiceSite === "" || formValue.ServiceSite === undefined || formValue.ServiceSite === 0 || formValue.ServiceSite === -1) {
      formValue.OptServiceSite = 0;
    } else {
      formValue.OptServiceSite = 1;
    }


    // **** Edit Or Create ***
    // if (this.ActivityEmpl) {
    //   formValue = { CusomerActivityId: this.ActivityEmpl.ID, ...formValue };
    // }
    /*
    Hour: 29
    Minute: 0
    StartTime: "202008021 08:26"
*/

    console.log('formValue', formValue);
    if (formValue.id > 0) {
      formValue.activityid =formValue.id
      formValue.method ="UpdateActivity"
    } else {
      formValue.method ="SaveActivity"
    }
    this.MapInformationService.SaveInfoSites(formValue).subscribe(
    // this.generalService.postInsertUpdategeneral('Activity/InsertUpdateActivity', null, formValue).subscribe(
      data => {
        console.log(data);

        if (formValue.id > 0) {
          // No reset form
          this.toast.success('Activity Edited Successfully');
        } else {
          this.toast.success('Activity Created  Successfully');
          this.initForm();

          if (closemodal) {
            this.closeModalOutput();
          }

          if (goedit) {
            this.router.navigateByUrl(`/employeeActivity/editEmployeeActivities/${data[0].ID}`);
          }
        }
        this.result.emit(data);

      },
      err => {
        console.log(err)
        if (this.ActivityEmpl) {
          this._formEntity.patchValue({ Minute: this.durationCovert(this.ActivityEmpl) });
        } else {
          this._formEntity.patchValue({ Minute: '00:01' });
        }
      }
    )

  }


  convertADate(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("");
  }
  getHour(str) {
    var date = new Date(str);
    let hour, min;
    if (date.getHours() < 10) {
      hour = '0' + date.getHours()
    } else { hour = date.getHours() }
    if (date.getMinutes() < 10) {
      min = '0' + date.getMinutes()
    } else { min = date.getMinutes() }
    return [hour, min].join(":");
  }

  optionsSelect(select) {
    console.log('optionsSelect');
    if (select === 'OptCustomer') {
      this._formEntity.patchValue({ OptCustomer: 1 });
      // this._formEntity.patchValue({ OptServiceSite: 0, ServiceSite: '' });
      // this._formEntity.patchValue({ OptProject: 0, Project: '' });
    }
    if (select === 'serviceSite') {
      // this._formEntity.patchValue({ OptCustomer: 0, Customer: '' });
      // this._formEntity.patchValue({ OptProject: 0, Project: '' });
      this._formEntity.patchValue({ OptServiceSite: 1 });
    }
    if (select === 'project') {
      // this._formEntity.patchValue({ OptServiceSite: 0, ServiceSite: '' });
      // this._formEntity.patchValue({ OptCustomer: 0, Customer: '' });
      this._formEntity.patchValue({ OptProject: 1 });
    }
  }

  closeModalOutput() {
    this.closeModal.emit(true);
    this.initForm()
  }

  getCustomer() {
    this.generalService.getPopulateGeneral('Customer/GetCustomerList').subscribe(
      data => {
        this.optionsCustomer = data.map((val) => {
          // console.log('GetCustomerList', val.value)
          return { // Return the new object structure
            Name: val.DESCRIPTION,
            ID: val.ID
          };
        });
      },
      err => {

      }
    )
  }
  getDataToSelects() {
    this.generalService.GetEmployees().subscribe(result => {
      this.optionsempleoyees = result.map((val) => {
        return { // Return the new object structure
          Name: val.CONTACTNAME, key: val.ID
        };
      });
      console.log('Employee', this.optionsempleoyees);
    });
    this.generalService.getPopulateGeneral('Customer/GetCustomerActivityType').subscribe(result => {
      this.optionsactivityType = result.map((val) => {
        return { // Return the new object structure
          Name: val.Name, key: val.ID
        };
      });
      console.log('GetCustomerActivityType', this.optionsactivityType);
    });
    this.generalService.getPopulateGeneral('Site').subscribe(result => {
      this.optionsSite = result.map((val) => {
        return { // Return the new object structure
          Name: val.SITENAME, ID: val.ID
        };
      });
      console.log('Site', this.optionsSite);
    });
    this.generalService.getPopulateGeneral('Project').subscribe(result => {
      this.optionsProject = result.map((val) => {
        return { // Return the new object structure
          Name: val.value, ID: val.ID
        };
      });
      console.log('Project', this.optionsProject);
    });
  }

  showInfo2() {
    this.popupCustomer = true;
  }
  //popupServiceSite
  showInfo3() {
    this.popupServiceSite = true;
  }
  resultulCustumerOriginal(e) {
    console.log('resultulCustumerOriginal', e);
    this.IdAutocomplete = e.id;

    this._formEntity.patchValue({ OptCustomer: 1, Customer: e.name });
    this._formEntity.patchValue({ OptServiceSite: 0, ServiceSite: '' });
    this._formEntity.patchValue({ OptProject: 0, Project: '' });
  }
  //outpu site
  resultNewCustomer(e) {
    console.log('resultNewCustomer', e);
    this.IdAutocomplete = e.id;

    this._formEntity.patchValue({ OptCustomer: 0, Customer: '' });
    this._formEntity.patchValue({ OptProject: 0, Project: '' });
    this._formEntity.patchValue({ OptServiceSite: 1, ServiceSite: e.name });
  }
  resultNewSite(e) {
    console.log('resultNewSite', e);
  }

  updateEmployeeInfo(e) {
    console.log('updateEmployeeInfo', e);
    if (e.selectedItem.ID) {
      this.IdAutocomplete = e.selectedItem.ID;
      this._formEntity.get("Customer").setValue(e.selectedItem.ID)
      this.CustomerName = e.selectedItem.Name

      // **************************
      this._formEntity.get("ServiceSite").setValue(0)
      this.SiteNameVar = ""

      this._formEntity.get("Project").setValue(0)
      this.Projetcname = ""
    }
  }

  updateEmployeeInfo1(e) {
    console.log('updateEmployeeInfo', e);
    if (e.selectedItem.ID) {
      this.IdAutocomplete = e.selectedItem.ID;
      this._formEntity.get("ServiceSite").setValue(e.selectedItem.ID)
      this.SiteNameVar = e.selectedItem.Name

      //************************* */
      this._formEntity.get("Project").setValue(0)
      this.Projetcname = ""

      this._formEntity.get("Customer").setValue(0)
      this.CustomerName = ""
    }
  }

  updateEmployeeInfo2(e) {
    console.log('updateEmployeeInfo', e);
    if (e.selectedItem.ID) {
      this.IdAutocomplete = e.selectedItem.ID;
      this._formEntity.get("Project").setValue(e.selectedItem.ID)
      this.Projetcname = e.selectedItem.Name

      // *********************
      this._formEntity.get("Customer").setValue(0)
      this.CustomerName = ""

      this._formEntity.get("ServiceSite").setValue(0)
      this.SiteNameVar = ""
    }
  }
  close() {
    console.log('close');
    this.NewCustomer.initForm();
    this.NewSite.initForm();

  }

  durationCovert(data: any) {
    let duration;
    let dutationSub1 = data.DURATION + '';
    if (data.DURATION % 1 == 0) {
      //alert ("Es un numero entero");
      duration = data.DURATION + ':00'
      if (duration.length < 5) {
        duration = '0' + duration;
      }
    } else {
      //alert ("Es un numero decimal");
      if (dutationSub1.length < 5) {
        if (data.DURATION < 10) {
          if (data.DURATION < 1) {
            if (dutationSub1.length > 3) {
              duration = 0 + dutationSub1.replace('.', ":");
            } else {
              duration = 0 + dutationSub1.replace('.', ":") + 0;
            }
          } else {
            duration = 0 + dutationSub1.replace('.', ":");
            if (duration.length < 5) {
              duration = duration + '0';
            }
          }
        } else {
          duration = dutationSub1.replace('.', ":");
          duration = duration + '0';
        }
      } else {
        duration = dutationSub1.replace('.', ":");
      }
    }
    return duration;
  }


}
